module.exports = __webpack_public_path__ + "static/media/rfb_testimonial1_henley.c1040efb.jpg";